import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=bccad284"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=bccad284&prod&module=attr&lang=stylus"




function injectStyles (context) {
  
  this["attr"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderTemplate: require('/var/www/malayan/web/components/global/templates/HeaderTemplate.vue').default,ButtonTemplate: require('/var/www/malayan/web/components/global/templates/ButtonTemplate.vue').default,CarouselDotsTemplate: require('/var/www/malayan/web/components/global/templates/CarouselDotsTemplate.vue').default})
